import { render, staticRenderFns } from "./TabHorizontal.vue?vue&type=template&id=7a452b4b&"
import script from "./TabHorizontal.vue?vue&type=script&lang=js&"
export * from "./TabHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports